import { EGeoSearchTypes } from '../constants';
import { ESuggestType } from '@cian/geosuggest-widget';
import { EGeoTypes } from '../constants/geoTypes';
import { IGeoStep } from '../types';
import { EStepField } from '../constants/stepField';

const MAP_SEARCH_TYPES_LAND = {
  [EGeoSearchTypes.REGION]: [
    {
      field: EStepField.area,
      title: 'Укажите населенный пункт, район или шоссе',
      types: [ESuggestType.city, ESuggestType.district, ESuggestType.road],
      placeholder: 'Населенный пункт, район или шоссе',
      placeholderExtra: 'Выберите еще населенный пункт, район или шоссе',
    },
  ],
  [EGeoSearchTypes.REGION_WITH_UNDERGROUND]: [
    {
      field: EStepField.area,
      title: 'Укажите населенный пункт, ближайшее метро, район или шоссе',
      types: [ESuggestType.city, ESuggestType.district, ESuggestType.road, ESuggestType.underground],
      placeholder: 'Населенный пункт, ближайшее метро, район или шоссе',
      placeholderExtra: 'Выберите еще населенный пункт, метро, район или шоссе',
    },
  ],
  [EGeoSearchTypes.CITY_WITH_DISTRICTS_UNDERGROUND]: [
    {
      field: EStepField.districts,
      title: 'Укажите район',
      types: [ESuggestType.district],
      placeholder: 'Название района',
      placeholderExtra: 'Выберите еще район',
    },
    {
      field: EStepField.undergrounds,
      title: 'Укажите ближайшее метро',
      types: [ESuggestType.underground],
      placeholder: 'Станция метро',
      placeholderExtra: 'Выберите еще станцию',
    },
  ],
  [EGeoSearchTypes.CITY_WITH_DISTRICTS]: [
    {
      field: EStepField.districts,
      title: 'Укажите район',
      types: [ESuggestType.district],
      placeholder: 'Название района',
      placeholderExtra: 'Выберите еще район',
    },
  ],
  [EGeoSearchTypes.CITY]: [
    {
      field: EStepField.streets,
      title: 'Укажите улицу',
      types: [EGeoTypes.street],
      placeholder: 'Улица',
      placeholderExtra: 'Выберите еще улицу',
    },
  ],
};

export const getExtraStepsLand = (searchType: EGeoSearchTypes): IGeoStep[] => {
  return MAP_SEARCH_TYPES_LAND[searchType] || [];
};
